<pm-forecast-chart
  (clickedPredictionPoint)="onPredictionPointClick($event)"
  (changedTimeRange)="updateSelectedTimeRange($event)"
/>

<div class="flex flex-col gap-8 px-4 py-8">
  <pm-forecast-applied-filters />
  <pm-forecast-kpis />
  <pm-selected-filter-combination-chips />

  <!-- expansion panels need less gap  -->
  <div class="flex flex-col gap-2">
    <pm-forecast-prediction-explanation
      [clickedPredictionPoint]="clickedDate"
    />
    <pm-forecast-feature-importance />
  </div>
</div>
